import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=32f04e0a&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=32f04e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f04e0a",
  null
  
)

export default component.exports